import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';

export const latestPlenarySnapshotIdQueryKey = ({
  plenaryDraftId,
  publishedOnly
}: {
  plenaryDraftId?: string;
  publishedOnly?: boolean;
}) => ['plenary-snapshot', 'latest-id', { plenaryDraftId, ...(publishedOnly && { publishedOnly }) }] as const;

export const getLatestPlenarySnapshotId = async ({
  plenaryDraftId,
  publishedOnly
}: {
  plenaryDraftId: string;
  publishedOnly?: boolean;
}) => {
  return apiCall(
    apiClient.GET('/plenary-snapshots/latest-id', {
      params: {
        query: {
          plenaryDraftId,
          ...(publishedOnly && { publishedOnly: 'true' })
        }
      }
    })
  );
};

export const useGetLatestPlenarySnapshotIdQuery = ({
  enabled,
  plenaryDraftId,
  publishedOnly
}: {
  enabled?: boolean;
  plenaryDraftId?: string;
  publishedOnly?: boolean;
}) => {
  return useQuery({
    queryKey: latestPlenarySnapshotIdQueryKey({ plenaryDraftId, publishedOnly }),
    queryFn: () =>
      getLatestPlenarySnapshotId({
        plenaryDraftId: plenaryDraftId as string,
        publishedOnly
      }),
    enabled: !!plenaryDraftId && enabled !== false
  });
};
